module.exports = __webpack_public_path__ + "static/247a5ee5637aa3b15149e6e245260a562fb070e614555eed16fe782be4c0d041-6a93604fea33382702a6447086a8ea35.png";